module.exports = __webpack_public_path__ + "static/enterprise-banner1-4e35fd3b88a248ce732811eff4a57981.svg";